import React from 'react';
import { useDispatch } from 'react-redux';
import '../styles/Header.css';
import { UserOutlined, LogoutOutlined, DownOutlined } from '@ant-design/icons';
import { logout } from '../slice/authSlice';
import { useNavigate } from 'react-router-dom';

export const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <header className="header">
     <div className="logo">
      <img src="https://www.ampstek.com/assets/img/logo6.png" alt="SRSINFOWAY Logo" />
    </div>
    <button className="logout-btn" onClick={handleLogout}>
    Logout
    </button>
  </header>
  );
};